import { PaymentApibuild } from '@utils/api-url-builder';

const API_RESOURCE_SEGMENT_URL = 'api/G11n';

export const URLS = {
  TRANSLATIONS: PaymentApibuild([API_RESOURCE_SEGMENT_URL], 'translations'),
  AVAILABLE_LANGS: PaymentApibuild([API_RESOURCE_SEGMENT_URL], 'available-langs')
};
